import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { useController } from 'react-hook-form';

const TextFieldInput = ({
  name,
  control,
  label,
  rules,
  variant = 'filled',
  style,
  className,
  InputProps,
  placeholder,
  type = 'text',
  defaultValue = '',
  id = '',
  adornment,
  adornmentPosition = 'end',
  disabled = false,
  helperText,
  ...props
}) => {
  const {
    field: { onChange, onBlur, value, ref },
    fieldState: { error },
  } = useController({
    name,
    control,
    rules,
    defaultValue,
  });

  const inputId = id || name;

  const handleKeyDown = (event) => {
    if (event.key === '-' || event.key === 'e' || event.key === '+') {
      event.preventDefault();
    }
  };

  return (
    <TextField
      label={label}
      size="small"
      margin="dense"
      fullWidth
      disabled={disabled}
      sx={style}
      variant={variant}
      value={value || ''}
      onChange={onChange}
      onBlur={onBlur}
      inputRef={ref}
      error={!!error}
      className={className}
      slotProps={{
        htmlInput: { min: 0, maxLength: 255, className: 'px-3' },
        input: {
          endAdornment: adornment && adornmentPosition === 'end' && (
            <InputAdornment position="end">
              {/* <span> */}
              {adornment}
              {/* </span> */}
            </InputAdornment>
          ),
          startAdornment: adornment && adornmentPosition === 'start' && (
            <InputAdornment position="start" className="px-3">
              {/* <span
                style={{ opacity: 0.5, fontSize: '0.875rem', color: '#000' }}
              > */}
              {adornment}
              {/* </span> */}
            </InputAdornment>
          ),
          // className: 'px-3',
          ...InputProps,
        },
      }}
      onKeyDown={type === 'number' ? (e) => handleKeyDown(e) : () => {}}
      helperText={error ? error.message : helperText}
      placeholder={placeholder}
      type={type}
      data-testid={props['data-testid']}
      id={inputId}
      {...props}
    />
  );
};

export default TextFieldInput;